import { ExtendedMap } from '@jeppesen-foreflight/jmkw-types';

type ThemeColors =
  | 'primary'
  | 'secondary'
  | 'accent'
  | 'warn'
  | 'info'
  | 'success'
  | 'error';

export class CheckboxNode {
  id!: string;
  label!: string;
  selected = false;
  indeterminate? = false;
  onChange?: (selected: boolean, node: CheckboxNode) => void;
  expanded? = false;
  color?: ThemeColors;
  order?: number;
  automationKey?: string;
  children: ExtendedMap<CheckboxNode> = new ExtendedMap();

  constructor(props: Partial<CheckboxNode>) {
    Object.assign(this, props);
  }
}
export function flattenNodeMap(nodes: ExtendedMap<CheckboxNode>) {
  const flattenedNodes: CheckboxNode[] = [];
  nodes.forEach((node) => {
    flattenedNodes.push(node);
    flattenedNodes.push(...flattenNodes(node));
  });
  return flattenedNodes;
}

// Function to recursively flatten ExtMap<CheckboxNode> and CheckboxNode
export function flattenNodes(node: CheckboxNode): CheckboxNode[] {
  let flattenedNodes: CheckboxNode[] = [];

  // Add current node
  flattenedNodes.push(node);

  // Recursively add children
  node.children.forEach((childNode) => {
    flattenedNodes = flattenedNodes.concat(flattenNodes(childNode));
  });

  return flattenedNodes;
}
